import React, { FC, ReactNode } from 'react';

import { Box } from '@rbilabs/universal-components';

import EmptyState from 'components/empty-state';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import { Wrap } from './styled';

interface IOrdersEmptyProps {
  children?: ReactNode;
}

const OrdersEmpty: FC<React.PropsWithChildren<IOrdersEmptyProps>> = ({ children }) => {
  return (
    <Box flexGrow="1">
      <Wrap>
        <EmptyState
          header={t('noOrdersItemsYet')}
          subheader={t('recentOrdersEmptySubHeader')}
          linkTo={routes.menu}
          linkText={t('startOrder')}
        />
      </Wrap>
      {children}
    </Box>
  );
};

export default OrdersEmpty;
